import { ClientProductFormValues } from 'types/clientProductFormTypes';

export const createClientProductFormValues = (): ClientProductFormValues => ({
  discountPercent: '',
  partnerPercent: '',
});
